import { render, staticRenderFns } from "./VerificationProgressHeader.vue?vue&type=template&id=ae6da0c0"
import script from "./VerificationProgressHeader.vue?vue&type=script&lang=js"
export * from "./VerificationProgressHeader.vue?vue&type=script&lang=js"
import style0 from "./VerificationProgressHeader.vue?vue&type=style&index=0&id=ae6da0c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports